import React, { useContext } from 'react';

import { useWeddingWebsiteQuery } from '../../generated/graphql';
import { PageCardUIContext } from '../../PageCardUIContext';
import CardContainer from '../CardContainer';
import { Page } from '../PageCard';
import AddToPageButton from '../PageCard/AddToPageButton';
import PageCardItems from '../PageCard/PageCardItems';
import PageHeader from '../PageCard/PageHeader';
import Card from '../Card';
import BasicInfoItem from './BasicInfoItem';
import useDatePref from '../../helpers/useDatePref';
import VerticalCoverPhoto from './VerticalCoverPhoto';

interface Props {
  page: Page;
}

export const WeddingPageCard: React.FC<Props> = ({ page }) => {
  const fixedPage = { ...page, title: 'Home' };
  const { isPageOpenObj, togglePageOpen } = useContext(PageCardUIContext);
  const open = isPageOpenObj[page.id];
  const { data } = useWeddingWebsiteQuery();
  const [weddingDateText] = useDatePref({
    isLiteSite: false,
  });

  // zero state in experiment has the same wedding & event cards as control.
  const hideDetails = Boolean(data?.weddingWebsite?.coverPhoto?.mediaUrl);

  const renderCoverPhoto = () => {
    return <VerticalCoverPhoto page={fixedPage} data={data} weddingDateText={weddingDateText} />;
  };

  const renderContent = () => {
    return (
      <>
        {renderCoverPhoto()}
        {hideDetails ? null : (
          <>
            <BasicInfoItem data={data} weddingDateText={weddingDateText} as="h3" />
            <PageCardItems page={fixedPage} />
            <AddToPageButton page={fixedPage} />
          </>
        )}
      </>
    );
  };

  return (
    <>
      <CardContainer id="wws-admin-home-card" page={page}>
        <Card>
          <PageHeader
            page={fixedPage}
            open={open}
            toggleOpen={(): void => togglePageOpen(page.id)}
            hasDropdown={false}
          />
          {open ? renderContent() : null}
        </Card>
      </CardContainer>
    </>
  );
};
